
import { defineComponent, ref, watch, onMounted } from "vue"
import { Actions } from "@/store/enums/StoreEnums"
import { useStore } from "vuex"
import { ElMessage } from "element-plus"
import { Loading } from '@element-plus/icons-vue'
import { ProbabilityItem } from "@/store/modules/CardPoolModule"

export default defineComponent({
  components: {
    Loading
  },
  props: {
    cardPoolId: {
      type: Number,
      required: true
    }
  },
  setup(props) {
    const store = useStore()
    const loading = ref(false)
    const probabilityList = ref<ProbabilityItem[]>([])

    const loadProbability = () => {
      loading.value = true
      store
        .dispatch(Actions.GET_CARD_POOL_PROBABILITY, props.cardPoolId)
        .then(() => {
          probabilityList.value = store.getters.currentCardPoolProbability
        })
        .catch(() => {
          ElMessage.error('获取概率数据失败')
        })
        .finally(() => {
          loading.value = false
        })
    }

    onMounted(() => {
      loadProbability()
    })

    watch(() => props.cardPoolId, () => {
      loadProbability()
    })

    const getRarityTagType = (rarity: string) => {
      const typeMap: Record<string, string> = {
        'R': 'info',
        'SR': '',
        'SSR': 'success',
        'SSSR': 'warning',
        'UR': 'danger',
        'SAR': 'danger'
      }
      return typeMap[rarity] || ''
    }

    const getProbabilityClass = (probability: number) => {
      if (probability >= 10) return 'text-success'
      if (probability >= 1) return 'text-primary'
      if (probability >= 0.1) return 'text-warning'
      return 'text-danger'
    }

    return {
      loading,
      probabilityList,
      getRarityTagType,
      getProbabilityClass
    }
  }
})
